import clsx from 'clsx'
import { nanoid } from 'nanoid'
import * as React from 'react'
import { useImperativeHandle, useRef, useState } from 'react'

import type { StyleProps } from '@/types'

import S, { CheckBoxWrap } from './_Checkbox.style'

export type Props = {
  name?: string
  checked?: boolean
  readOnly?: boolean
  indeterminate?: boolean
  disabled?: boolean
  isLabelDisabled?: boolean
  defaultChecked?: boolean
  text?: React.ReactNode
  onChange?: (changed: boolean) => void
  onClick?: (e: React.MouseEvent<HTMLLabelElement>) => void
} & StyleProps

/**
 * @deprecated 디자인시스템의 createCheckbox를 사용하세요.
 */
const _Checkbox = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      name = '',
      checked,
      readOnly = false,
      indeterminate = false,
      disabled = false,
      isLabelDisabled = false,
      text,
      defaultChecked,
      onChange,
      style,
      className,
      onClick,
      ...props
    },
    ref,
  ) => {
    const inputRef = useRef<HTMLInputElement>(null)
    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement)

    const [id] = useState(nanoid())
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      onChange?.(e.target.checked)
    }

    return (
      <CheckBoxWrap
        style={style}
        className={clsx(className, disabled && 'disabled')}
        htmlFor={id}
        onClick={onClick}
        {...props}
      >
        <input
          ref={inputRef}
          id={id}
          checked={checked}
          readOnly={readOnly}
          type="checkbox"
          name={name as string}
          onChange={onChange ? handleChange : undefined}
          onClick={(event) => {
            event.stopPropagation()
          }}
          defaultChecked={defaultChecked}
          data-indeterminate={indeterminate}
          disabled={disabled}
        />
        <label className="checkbox_label" css={S.checkedLabel} htmlFor={id} />
        {text && (
          <label className={clsx('with-text', isLabelDisabled && 'disabled')} htmlFor={id}>
            {text}
          </label>
        )}
      </CheckBoxWrap>
    )
  },
)

_Checkbox.displayName = '_Checkbox'

export default _Checkbox
